import {populateCareerIdeasForUser, populateCareerIdeaDetail, createOrUpdateCareerIdea, deleteCareerIdea, populateCareerIdeas, populateConnectionDetail,
  createOrUpdateConnection, deleteConnection, populateConnections, saveConnectionNote, saveCareerIdeaAndConnection, getCareerIdeaAndConnection,
  getCareerIdeaAndConnectionForUser} from '../api'

export const createCareerIdea = ({ state, commit }, data) => {
  return createOrUpdateCareerIdea(data)
}

export const loadCareerIdeaDetail = ({ state, commit }, uuid) => {
  return populateCareerIdeaDetail(uuid)
}

export const deleteCareerIdeaDetail = ({ state, commit }, uuid) => {
  return deleteCareerIdea(uuid)
}

export const loadCareerIdeas = ({ state, commit }) => {
  return populateCareerIdeas()
}

export const loadCareerIdeasForUser = ({ state, commit }, {userId, index}) => {
  return populateCareerIdeasForUser(userId).then(res => {
    var response = {
      'data': res,
      'index': index
    }
    return response
  })
}

export const createConnection = ({ state, commit }, data) => {
  return createOrUpdateConnection(data)
}

export const loadConnectionDetail = ({ state, commit }, uuid) => {
  return populateConnectionDetail(uuid)
}

export const deleteConnectionDetail = ({ state, commit }, uuid) => {
  return deleteConnection(uuid)
}

export const loadConnections = ({ state, commit }, careerIdeaId) => {
  return populateConnections(careerIdeaId)
}

export const addConnectionNote = ({ state, commit }, data) => {
  return saveConnectionNote(data)
}

export const createCareerIdeaAndConnection = ({ state, commit }, data) => {
  return saveCareerIdeaAndConnection(data)
}

export const loadCareerIdeaAndConnection = ({ state, commit }, { courseId, isMainQuest }) => {
  return getCareerIdeaAndConnection(courseId, isMainQuest)
}

export const loadCareerIdeaAndConnectionForUser = ({ state, commit }, { courseId, userId, isMainQuest }) => {
  return getCareerIdeaAndConnectionForUser(courseId, userId, isMainQuest)
}



// WEBPACK FOOTER //
// ./src/app/quest/vuex/actions.js